import { useContent } from '@/content'
import { ROUTES } from '@/lib/paths'
import { BrandIcon, Button, Section, Surface } from '@/components/ui'
import { ExpertiseMarquee } from '@/features/expertise'
import { ProfileCard, ResumeButton, highlight } from '@/features/profile'
import styles from './HeroSection.module.css'

/**
 * The introduction: who he is, beside what he works with.
 *
 * One band holding the profile card, the tool grid and the statement panel,
 * as on the reference build — the skills are part of the introduction, not a
 * section of their own.

 */
export const HeroSection = () => {
  const { expertiseStatement, tools } = useContent()

  return (
  <Section aria-labelledby="hero-name" innerClassName={styles.grid} id="work">
    <ProfileCard
      headingId="hero-name"
      headingLevel="h2"
      emphasise={['Digital Engineer', 'UI/UX', 'full-stack', 'cloud']}
      actions={
        <>
          <Button to={ROUTES.about} icon="arrowUpRight">
            About me
          </Button>
          <ResumeButton variant="secondary" label="Download CV" />
        </>
      }
    />

    <div className={styles.column}>
      <Surface pad={20} radius="card" className={styles.skills}>
        <h2 className="t-24">My Expert area</h2>
        <div className={styles.toolGrid}>
          {tools.map((tool) => (
            <Surface
              key={tool.id}
              as="a"
              href={tool.href}
              target="_blank"
              rel="noreferrer noopener"
              interactive
              className={styles.tool}
            >
              <BrandIcon name={tool.icon} size={30} className={styles.toolLogo} />
              <span className={`t-18 ${styles.toolName}`}>{tool.name}</span>
            </Surface>
          ))}
        </div>
      </Surface>

      <Surface pad={20} radius="card" className={styles.statementPanel}>
        <p className={`t-14 ${styles.statement}`}>
          {highlight(
            expertiseStatement,
            'brand and interface design',
            'React and Node',
            'cloud infrastructure and pipelines',
          )}
        </p>

        <ExpertiseMarquee />
      </Surface>
    </div>
  </Section>
  )
}
